'use client';

import {
	VelocityClient,
	isVariant,
	PerpMarketAccount,
} from '@velocity-exchange/sdk';
import { MarketId } from '@velocity-exchange/common';
import { useEffect, useState } from 'react';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import useDriftClientIsReady from './useDriftClientIsReady';

export const getTargetPerpMarketAccount = (
	selectedMarketIndex: number,
	driftClient: VelocityClient
) => {
	return driftClient.getPerpMarketAccount(selectedMarketIndex);
};

export const useTargetPerpMarketAccount = (marketId?: MarketId) => {
	const driftClient = useDriftStore((s) => s.driftClient.client);
	const driftClientIsReady = useDriftClientIsReady();

	const [marketAccount, setMarketsAccount] = useState<
		PerpMarketAccount | undefined
	>(undefined);

	// Keep markets account in state in sync with blockchain
	useEffect(() => {
		if (
			!marketId ||
			!driftClientIsReady ||
			!isVariant(marketId.marketType, 'perp') ||
			!driftClient
		) {
			setMarketsAccount(undefined);
			return;
		}

		setMarketsAccount(
			getTargetPerpMarketAccount(marketId.marketIndex, driftClient)
		);

		const updateHandler = () => {
			setMarketsAccount(
				getTargetPerpMarketAccount(marketId.marketIndex, driftClient)
			);
		};

		driftClient.eventEmitter.on('update', updateHandler);

		return () => {
			//todo
			try {
				driftClient.eventEmitter.removeListener('update', updateHandler);
			} catch (e) {
				// Do nothing
			}
		};
	}, [driftClient, driftClientIsReady, marketId]);

	return marketAccount;
};
